/* --- theme.js --- */
(() => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  const header = document.querySelector('[data-site-header]');

  if (toggle && menu && header) {
    let menuTimer;
    let resizeObserver;

    const syncMenuWidth = () => {
      if (!menu.hidden) {
        header.style.setProperty('--devico-menu-width', `${menu.getBoundingClientRect().width}px`);
      }
    };

    const setMenu = (open, restoreFocus = false) => {
      window.clearTimeout(menuTimer);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', String(!open));
      menu.inert = !open;

      if (open) {
        menu.hidden = false;
        syncMenuWidth();
        window.requestAnimationFrame(() => menu.classList.add('is-open'));
        resizeObserver?.observe(menu);
      } else {
        menu.classList.remove('is-open');
        resizeObserver?.disconnect();
        menuTimer = window.setTimeout(() => {
          menu.hidden = true;
          menu.inert = true;
          header.style.removeProperty('--devico-menu-width');
        }, 360);
      }

      if (restoreFocus) toggle.focus();
    };

    resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(syncMenuWidth) : null;
    menu.inert = true;
    menu.setAttribute('aria-hidden', 'true');

    toggle.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) setMenu(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setMenu(false, true);
      }
    });

    document.addEventListener('pointerdown', (event) => {
      if (
        toggle.getAttribute('aria-expanded') === 'true' &&
        !menu.contains(event.target) &&
        !toggle.contains(event.target)
      ) {
        setMenu(false);
      }
    });

    window.addEventListener('resize', syncMenuWidth, { passive: true });
  }


  const story = document.querySelector('[data-making-story]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (story && !reduceMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    story.classList.add('making-story--motion');
    story.querySelectorAll('[data-making-reveal]').forEach((item) => observer.observe(item));
  }
})();

;
/* --- site-interactions.js --- */
(() => {
  const header = document.querySelector('[data-site-header]');

  /* DevīCo header: normal flow at page top; fixed at the viewport top after scrolling.
     A measured spacer preserves document geometry while the header is fixed. */
  if (header) {
    const spacer = document.createElement('div');
    spacer.className = 'devico-header-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    spacer.hidden = true;
    header.insertAdjacentElement('afterend', spacer);

    const setRibbonState = () => {
      const scrolled = window.scrollY > 2;
      header.classList.toggle('is-scrolled', scrolled);
      if (scrolled) {
        spacer.hidden = false;
        spacer.style.height = `${header.getBoundingClientRect().height}px`;
      } else {
        spacer.hidden = true;
        spacer.style.height = '0px';
      }
    };
    setRibbonState();
    window.addEventListener('scroll', setRibbonState, { passive: true });
    window.addEventListener('resize', setRibbonState, { passive: true });
  }

  /* Product mega menu */
  const productsNav = header && header.querySelector('[data-products-nav]');
  const productsToggle = header && header.querySelector('[data-products-menu-toggle]');
  const productsMenu = header && header.querySelector('[data-products-menu]');
  let closeTimer;

  if (productsNav && productsToggle && productsMenu) {
    const clearClose = () => window.clearTimeout(closeTimer);
    const closeProducts = (restoreFocus = false, immediate = false) => {
      clearClose();
      productsToggle.setAttribute('aria-expanded', 'false');
      productsMenu.classList.remove('is-open');
      closeTimer = window.setTimeout(() => { productsMenu.hidden = true; }, immediate ? 0 : 220);
      if (restoreFocus) productsToggle.focus();
    };
    const openProducts = () => {
      clearClose();
      productsMenu.hidden = false;
      productsToggle.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => productsMenu.classList.add('is-open'));
    };
    const scheduleClose = () => {
      clearClose();
      closeTimer = window.setTimeout(() => closeProducts(), 180);
    };

    productsToggle.addEventListener('click', () => {
      if (productsToggle.getAttribute('aria-expanded') === 'true') closeProducts();
      else openProducts();
    });
    productsToggle.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') openProducts();
    });
    productsMenu.addEventListener('pointerenter', clearClose);
    productsMenu.addEventListener('pointerleave', scheduleClose);
    productsNav.addEventListener('pointerleave', scheduleClose);
    productsNav.addEventListener('focusout', (event) => {
      if (!productsNav.contains(event.relatedTarget) && !productsMenu.contains(event.relatedTarget)) scheduleClose();
    });
    productsMenu.addEventListener('focusin', clearClose);
    productsMenu.addEventListener('focusout', (event) => {
      if (!productsMenu.contains(event.relatedTarget) && !productsNav.contains(event.relatedTarget)) scheduleClose();
    });
    productsMenu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeProducts(true, true);
    });
    productsToggle.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeProducts(true, true);
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        openProducts();
        window.requestAnimationFrame(() => productsMenu.querySelector('a')?.focus());
      }
    });
    productsMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => closeProducts()));
    document.addEventListener('pointerdown', (event) => {
      if (!header.contains(event.target)) closeProducts();
    });
  }

  /* Mobile products */
  const mobileProductsToggle = document.querySelector('[data-mobile-products-toggle]');
  const mobileProductsList = document.querySelector('[data-mobile-products-list]');
  if (mobileProductsToggle && mobileProductsList) {
    mobileProductsToggle.addEventListener('click', () => {
      const opening = mobileProductsList.hidden;
      mobileProductsToggle.setAttribute('aria-expanded', String(opening));
      mobileProductsToggle.querySelector('.mobile-menu__action').textContent = '+';
      if (opening) {
        mobileProductsList.hidden = false;
        window.requestAnimationFrame(() => mobileProductsList.classList.add('is-open'));
      } else {
        mobileProductsList.classList.remove('is-open');
        window.setTimeout(() => { mobileProductsList.hidden = true; }, 220);
      }
    });
  }

  /* DevīCo search — clean editorial field + adaptive top searches + Shopify query suggestions */
  const searchRoot = document.querySelector('[data-header-search]');
  const siteHeader = document.querySelector('[data-site-header]');
  const setSearchLayoutState = (open) => {
    siteHeader?.classList.toggle('search-open', open);
    document.body.classList.toggle('search-is-open', open);
  };
  const searchTrigger = document.querySelector('[data-search-trigger]');
  const searchForm = document.querySelector('[data-search-form]');
  const searchInput = document.querySelector('[data-search-input]');
  const searchClose = document.querySelector('[data-search-close]');
  const suggestions = document.querySelector('[data-search-suggestions]');
  let searchAbort;
  let searchTimer;
  const searchStatsKey = 'devico:search-stats:v1';
  const recentKey = 'devico:recent-searches:v1';
  const likesKey = 'devico:liked-products:v1';
  const escapeHTML = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
  }[character]));

  const readJSON = (key, fallback) => {
    try { return JSON.parse(localStorage.getItem(key) || JSON.stringify(fallback)); } catch (_) { return fallback; }
  };
  const readSearchStats = () => readJSON(searchStatsKey, {});
  const recordSearch = (term) => {
  const clean = String(term || '').trim();
  const normalized = clean.toLowerCase();
  if (!normalized || normalized.length < 2) return;
  const stats = readSearchStats();
  stats[normalized] = Math.min(999, Number(stats[normalized] || 0) + 1);
  localStorage.setItem(searchStatsKey, JSON.stringify(stats));
  const recent = readJSON(recentKey, []).filter(t => String(t).toLowerCase() !== normalized);
  recent.unshift(clean);
  localStorage.setItem(recentKey, JSON.stringify(recent.slice(0, 5)));
};
  const getSeedSearches = () => {
    const raw = searchForm?.dataset.topSearches || '';
    const stats = readSearchStats();
    const seeds = raw.split(/\r?\n/).map(item => item.trim()).filter(Boolean).slice(0, 12);
    return seeds
      .map(text => ({ text, score: Number(stats[text.toLowerCase()] || 0) }))
      .sort((a, b) => b.score - a.score || a.text.localeCompare(b.text))
      .slice(0, 6);
  };

  const renderTopSearches = () => {
    const items = getSeedSearches();
    const liked = readJSON(likesKey, []);
    const likedTypes = liked.map(item => String(item.type || '').toLowerCase()).filter(Boolean);
    const boosted = items.map(item => {
      const match = likedTypes.some(type => type && item.text.toLowerCase().includes(type));
      return { ...item, score: item.score + (match ? 2 : 0) };
    }).sort((a,b) => b.score - a.score || a.text.localeCompare(b.text));
    const compact = window.matchMedia('(max-width: 720px)').matches;
    
    const recent = readJSON(recentKey, []).slice(0, 5);
    const recentMarkup = recent.length
  ? `<div class="search-suggestions__heading search-suggestions__heading--recent"><span>RECENT SEARCHES</span><button type="button" class="search-recent-clear" data-clear-recent-searches>Clear</button></div>` +
    recent.map(text => `<a class="search-top-search" href="${searchForm.action}?q=${encodeURIComponent(text)}" data-search-term="${escapeHTML(text)}"><span>${escapeHTML(text)}</span><span aria-hidden="true">↗</span></a>`).join('')
  : '';

    suggestions.innerHTML = recentMarkup +  `<div class="search-suggestions__heading"><span>${compact ? 'EXPLORE <span class="brand-case">DevīCo</span>' : 'EXPLORE SEARCHES'}</span>${compact ? '<span>SHOP BY FORM</span>' : ''}</div>` +
      boosted.map(item => `<a class="search-top-search" href="${searchForm.action}?q=${encodeURIComponent(item.text)}" data-search-term="${escapeHTML(item.text)}"><span>${escapeHTML(item.text)}</span><span aria-hidden="true">↗</span></a>`).join('');
    suggestions.hidden = false;
  };

  if (searchRoot && searchTrigger && searchForm && searchInput && searchClose && suggestions) {
    let searchCloseTimer;
    const closeSearch = (restoreFocus = false) => {
      if (searchAbort) searchAbort.abort();
      window.clearTimeout(searchCloseTimer);
      searchTrigger.setAttribute('aria-expanded', 'false');
      searchRoot.classList.remove('is-open');
      searchRoot.classList.add('is-closing');
      setSearchLayoutState(false);
      suggestions.hidden = true;
      suggestions.innerHTML = '';
      searchInput.value = '';
      searchCloseTimer = window.setTimeout(() => {
        searchForm.hidden = true;
        searchRoot.classList.remove('is-closing');
      }, 260);
      if (restoreFocus) window.requestAnimationFrame(() => searchTrigger.focus());
    };

    const updateSearchPlaceholder = () => {
      const compact = window.matchMedia('(max-width: 720px)').matches;
      searchInput.placeholder = compact ? 'SEARCH FOR...' : 'Search pieces';
    };
    updateSearchPlaceholder();
    window.addEventListener('resize', updateSearchPlaceholder, { passive: true });

    const openSearch = () => {
      window.clearTimeout(searchCloseTimer);
      searchRoot.classList.remove('is-closing');
      searchTrigger.setAttribute('aria-expanded', 'true');
      searchForm.hidden = false;
      setSearchLayoutState(true);
      window.requestAnimationFrame(() => {
        searchRoot.classList.add('is-open');
        renderTopSearches();
        window.requestAnimationFrame(() => searchInput.focus());
      });
    };

    const renderSuggestions = (products, queries, query) => {
      const queryLinks = (queries || []).slice(0, 4).map((item) => {
        const text = item.text || item.styled_text || '';
        if (!text) return '';
        return `<a class="search-query-suggestion" href="${searchForm.action}?q=${encodeURIComponent(text)}" data-search-term="${escapeHTML(text)}"><span>${escapeHTML(text)}</span><span aria-hidden="true">↗</span></a>`;
      }).join('');
      const productMarkup = products.slice(0, 5).map((product) => {
        const image = product.image || product.featured_image?.url || '';
        const title = product.title || 'Piece';
        const type = product.type || '';
        return `
          <a class="search-suggestion" href="${escapeHTML(product.url || '#')}">
            ${image ? `<img class="search-suggestion__image" src="${escapeHTML(image)}" alt="" loading="lazy">` : '<span class="search-suggestion__image" aria-hidden="true"></span>'}
            <span class="search-suggestion__copy">
              <span class="search-suggestion__title">${escapeHTML(title)}</span>
              ${type ? `<span class="search-suggestion__meta">${escapeHTML(type)}</span>` : ''}
            </span>
            <span class="search-suggestion__arrow" aria-hidden="true">↗</span>
          </a>`;
      }).join('');
      if (!products.length && !queryLinks) {
        suggestions.innerHTML = `<div class="search-suggestions__empty">No pieces found for “${escapeHTML(query)}”.</div><a class="search-suggestions__search" href="${searchForm.action}?q=${encodeURIComponent(query)}">View all results ↗</a>`;
      } else {
        suggestions.innerHTML = (queryLinks ? `<div class="search-suggestions__heading"><span>SUGGESTED SEARCHES</span><span>FROM <span class="brand-case">DevīCo</span> SEARCH</span></div>${queryLinks}` : '') +
          (productMarkup ? `<div class="search-suggestions__heading search-suggestions__heading--products"><span>PIECES</span><span>${products.length} MATCHES</span></div>${productMarkup}` : '') +
          `<a class="search-suggestions__search" href="${searchForm.action}?q=${encodeURIComponent(query)}">View all results for “${escapeHTML(query)}” ↗</a>`;
      }
      suggestions.hidden = false;
    };

    const fetchSuggestions = (query) => {
      if (searchAbort) searchAbort.abort();
      const trimmed = query.trim();
      if (trimmed.length < 2) { renderTopSearches(); return; }
      searchAbort = new AbortController();
      const params = new URLSearchParams({
        q: trimmed,
        'resources[type]': 'product,query',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'hide'
      });
      const predictiveRoot = window.Shopify?.routes?.root || '/';
      fetch(`${predictiveRoot}search/suggest.json?${params.toString()}`, { headers: { 'Accept': 'application/json' }, signal: searchAbort.signal })
        .then(response => { if (!response.ok) throw new Error('Predictive search unavailable'); return response.json(); })
        .then(data => {
          const products = data.resources?.results?.products || [];
          const queries = data.resources?.results?.queries || [];
          renderSuggestions(products, queries, trimmed);
        })
        .catch(error => {
          if (error.name === 'AbortError') return;
          suggestions.innerHTML = `<a class="search-suggestions__search" href="${searchForm.action}?q=${encodeURIComponent(trimmed)}">Search for “${escapeHTML(trimmed)}” ↗</a>`;
          suggestions.hidden = false;
        });
    };

    searchTrigger.addEventListener('click', () => { if (searchForm.hidden) openSearch(); else searchInput.focus(); });
    searchClose.addEventListener('click', () => closeSearch(true));
    searchInput.addEventListener('input', () => {
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(() => fetchSuggestions(searchInput.value), 140);
    });
    searchForm.addEventListener('submit', () => { const term = searchInput.value.trim(); if (!term) return; searchInput.value = term; recordSearch(term); });
    suggestions.addEventListener('click', (event) => {
      const clearButton = event.target.closest('[data-clear-recent-searches]');
      if (clearButton) {
        try { localStorage.removeItem(recentKey); } catch (_) {}
        renderTopSearches();
        return;
      }
      const link = event.target.closest('[data-search-term]');
      if (link) recordSearch(link.dataset.searchTerm || '');
    });
    searchForm.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeSearch(true); });
    document.addEventListener('pointerdown', (event) => { if (!searchRoot.contains(event.target)) closeSearch(); });
  }

  /* Home/story reveals */
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const story = document.querySelector('[data-home-making]');
  if (story && !reduceMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.07 });
    story.classList.add('home-making--motion');
    story.querySelectorAll('[data-home-reveal]').forEach((item) => observer.observe(item));
  }
})();

;
/* --- account-drawer.js --- */
(() => {
  const drawer = document.querySelector('[data-account-drawer]');
  const backdrop = document.querySelector('[data-account-backdrop]');
  const openButton = document.querySelector('[data-account-open]');
  if (!drawer || !backdrop || !openButton) return;

  const likesKey = 'devico:liked-products:v1';
  const getLikes = () => {
    try { return JSON.parse(localStorage.getItem(likesKey) || '[]'); } catch (_) { return []; }
  };
  const saveLikes = (items) => localStorage.setItem(likesKey, JSON.stringify(items.slice(0, 60)));
  const countNodes = document.querySelectorAll('[data-liked-count]');
  const likesView = drawer.querySelector('[data-account-likes]');
  const likedGrid = drawer.querySelector('[data-liked-grid]');
  const likedEmpty = drawer.querySelector('[data-liked-empty]');
  const likedViewCount = drawer.querySelector('[data-liked-view-count]');
  const drawerInner = drawer.querySelector('.account-drawer__inner');
  const edgeControl = drawer.querySelector('[data-account-edge-control]');
  const mainSections = drawer.querySelectorAll('.account-drawer__section, .account-drawer__header, .account-profile-card');
  let accountPreviousFocus = null;
  let accountPreviousOverflow = '';
  drawer.setAttribute('role', 'dialog');
  drawer.setAttribute('aria-modal', 'true');
  drawer.setAttribute('tabindex', '-1');
  drawer.inert = true;
  const trapAccountFocus = (event) => {
    if (event.key !== 'Tab' || drawer.getAttribute('aria-hidden') !== 'false') return;
    const items = [...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el => !el.hidden && el.getClientRects().length);
    if (!items.length) { event.preventDefault(); drawer.focus(); return; }
    if (event.shiftKey && document.activeElement === items[0]) { event.preventDefault(); items[items.length - 1].focus(); }
    else if (!event.shiftKey && document.activeElement === items[items.length - 1]) { event.preventDefault(); items[0].focus(); }
  };

  const syncCount = () => countNodes.forEach(node => node.textContent = getLikes().length);
  const escapeHTML = (value) => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));
  const renderLikes = () => {
    const likes = getLikes();
    likedGrid.innerHTML = likes.map((item, index) => `
      <article class="account-liked-card">
        <a class="account-liked-card__image" href="${escapeHTML(item.url || '#')}" data-account-nav><img src="${escapeHTML(item.image || '')}" alt="" loading="lazy"></a>
        <button type="button" class="account-liked-card__remove" data-like-remove="${index}" aria-label="Remove ${escapeHTML(item.title)} from liked pieces">×</button>
        <div class="account-liked-card__copy"><strong>${escapeHTML(item.title)}</strong><span>${escapeHTML(item.price || '')}</span></div>
      </article>`).join('');
    likedEmpty.hidden = likes.length !== 0;
    likedGrid.hidden = likes.length === 0;
    if (likedViewCount) likedViewCount.textContent = `${String(likes.length).padStart(2, '0')} ${likes.length === 1 ? 'PIECE' : 'PIECES'}`;
    likedGrid.querySelectorAll('[data-like-remove]').forEach(button => button.addEventListener('click', () => {
      const next = getLikes(); next.splice(Number(button.dataset.likeRemove), 1); saveLikes(next); renderLikes(); syncCount();
      document.dispatchEvent(new CustomEvent('devico:likes-updated'));
    }));
  };

  const open = () => {
    accountPreviousFocus = document.activeElement;
    accountPreviousOverflow = document.body.style.overflow;
    backdrop.hidden = false;
    drawer.inert = false;
    backdrop.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    openButton.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => backdrop.classList.add('is-visible'));
    document.body.classList.add('account-drawer-open');
    document.body.style.overflow = 'hidden';
    renderLikes(); syncCount();
    edgeControl?.focus();
  };
  const close = () => {
    backdrop.classList.remove('is-visible');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    backdrop.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    openButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('account-drawer-open');
    document.body.style.overflow = accountPreviousOverflow;
    window.setTimeout(() => { backdrop.hidden = true; }, 350);
    showMain();
    if (accountPreviousFocus && typeof accountPreviousFocus.focus === 'function') accountPreviousFocus.focus();
  };
  const showLikes = () => {
    mainSections.forEach(node => node.hidden = true);
    likesView.hidden = false;
    drawer.dataset.accountViewState = 'likes';
    if (edgeControl) edgeControl.setAttribute('aria-label', 'Back to profile');
    if (drawerInner) drawerInner.scrollTop = 0;
    renderLikes();
  };
  const showMain = () => {
    likesView.hidden = true;
    mainSections.forEach(node => node.hidden = false);
    drawer.dataset.accountViewState = 'profile';
    if (edgeControl) edgeControl.setAttribute('aria-label', 'Close profile');
    if (drawerInner) drawerInner.scrollTop = 0;
  };

  openButton.addEventListener('click', open);
  edgeControl?.addEventListener('click', () => {
    if (drawer.dataset.accountViewState === 'likes') showMain();
    else close();
  });
  backdrop.addEventListener('click', close);
  drawer.querySelector('[data-account-view="likes"]')?.addEventListener('click', showLikes);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') { e.preventDefault(); close(); }
    else trapAccountFocus(e);
  });
  syncCount();
})();

// Product likes: browser-persistent personal wishlist, shared by product cards and account drawer.
(() => {
  const key = 'devico:liked-products:v1';
  const read = () => { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (_) { return []; } };
  const write = items => localStorage.setItem(key, JSON.stringify(items.slice(0, 60)));
  const refresh = () => {
    const liked = new Set(read().map(item => String(item.id)));
    document.querySelectorAll('[data-like-product]').forEach(button => {
      const active = liked.has(String(button.dataset.productLikeId));
      button.classList.toggle('is-liked', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? 'Remove' : 'Like'} ${button.dataset.productLikeTitle || 'piece'}`);
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-like-product]');
    if (!button) return;
    event.preventDefault();
    const id = String(button.dataset.productLikeId);
    let liked = read();
    const wasLiked = liked.some(item => String(item.id) === id);
    if (wasLiked) {
      liked = liked.filter(item => String(item.id) !== id);
    } else {
      liked.unshift({id, title: button.dataset.productLikeTitle, type: button.dataset.productLikeType || '', url: button.dataset.productLikeUrl, image: button.dataset.productLikeImage, price: button.dataset.productLikePrice});
    }
    // Re-trigger the small heart/border animation on every save action.
    button.classList.remove('like-animating');
    void button.offsetWidth;
    if (!wasLiked) button.classList.add('like-animating');
    write(liked); refresh(); document.dispatchEvent(new CustomEvent('devico:likes-updated'));
  });
  document.addEventListener('devico:likes-updated', refresh);
  document.addEventListener('devico:product-cards:rendered', refresh);
  refresh();
})();

;
/* --- cart-drawer.js --- */
/**
 * DevīCo — AJAX Cart Drawer
 * Handles: open/close, quantity ±, remove, live subtotal, bag count badge
 * Works with Shopify /cart.js, /cart/change.js, /cart/add.js
 */
(function () {
  'use strict';

  const SELECTORS = {
    drawer:       '[data-cart-drawer]',
    backdrop:     '[data-cart-backdrop]',
    closeBtn:     '[data-cart-drawer-close]',
    linesWrap:    '[data-cart-lines]',
    emptyState:   '[data-cart-empty]',
    subtotal:     '[data-cart-subtotal]',
    count:        '[data-cart-count]',
    countBadge:   '.bag-count',
    bagTrigger:   '[data-bag-trigger]',
    loading:      '[data-cart-loading]',
    shippingFill: '[data-shipping-fill]',
    shippingText: '[data-shipping-text]',
    toast:        '[data-cart-toast]',
    addForms:     'form[action="/cart/add"]',
  };

  // ── Free shipping threshold (set to 0 to disable bar) ──
  const FREE_SHIPPING_THRESHOLD = Number(window.DEVICO_CONFIG?.freeShippingThreshold || 299900);

  let drawer, backdrop, loading, toast;
  let isLoading = false;
  let cartPreviousFocus = null;
  let cartPreviousOverflow = '';

  function trapCartFocus(event) {
    if (event.key !== 'Tab' || !drawer || drawer.getAttribute('aria-hidden') !== 'false') return;
    const items = Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'))
      .filter(el => !el.hidden && el.getAttribute('aria-hidden') !== 'true' && el.getClientRects().length);
    if (!items.length) { event.preventDefault(); drawer.focus(); return; }
    const first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  // ── Init ──────────────────────────────────────────────
  function init() {
    drawer    = document.querySelector(SELECTORS.drawer);
    backdrop  = document.querySelector(SELECTORS.backdrop);
    loading   = drawer && drawer.querySelector(SELECTORS.loading);
    toast     = document.querySelector(SELECTORS.toast);
    if (!drawer) return;

    // Close buttons
    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(btn =>
      btn.addEventListener('click', closeDrawer)
    );
    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    // Bag trigger in header opens drawer
    document.querySelectorAll(SELECTORS.bagTrigger).forEach(el =>
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
        fetchAndRender();
      })
    );

    // Intercept all add-to-cart form submissions
    document.addEventListener('submit', function (e) {
      const form = e.target.closest('form[action="/cart/add"], form.product-form');
      if (!form) return;
      const atelier = form.querySelector('[data-atelier-add]');
      if (atelier && !atelier.hidden) return; // let Atelier handle its own submit
      e.preventDefault();
      addToCart(form);
    });

    // ESC to close
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer?.getAttribute('aria-hidden') === 'false') { e.preventDefault(); closeDrawer(); }
      else trapCartFocus(e);
    });

    // Refresh count on init
    fetchCartCount();
  }

  // ── Open / Close ──────────────────────────────────────
  function openDrawer() {
    if (!drawer) return;
    cartPreviousFocus = document.activeElement;
    cartPreviousOverflow = document.body.style.overflow;
    drawer.classList.add('is-open');
    if (backdrop) { backdrop.classList.add('is-open'); backdrop.setAttribute('aria-hidden', 'false'); }
    drawer.setAttribute('aria-hidden', 'false');
    drawer.inert = false;
    document.body.style.overflow = 'hidden';
    const closeBtn = drawer.querySelector('[data-cart-drawer-close]');
    if (closeBtn) closeBtn.focus();
    document.dispatchEvent(new CustomEvent('devico:cart:open'));
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (backdrop) { backdrop.classList.remove('is-open'); backdrop.setAttribute('aria-hidden', 'true'); }
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    document.body.style.overflow = cartPreviousOverflow;
    if (cartPreviousFocus && typeof cartPreviousFocus.focus === 'function') cartPreviousFocus.focus();
    document.dispatchEvent(new CustomEvent('devico:cart:close'));
  }

  // ── Add to cart ───────────────────────────────────────
  async function addToCart(form) {
    if (isLoading) return;
    setLoading(true);
    const formData = new FormData(form);
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) throw new Error('add failed');
      await fetchAndRender();
      openDrawer();
      showToast('Piece entered the bag');
    } catch (err) {
      console.error('[DevīCo cart] add error', err);
      showToast('Unable to add. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  // ── Fetch cart and render ──────────────────────────────
  async function fetchAndRender() {
    if (!drawer) return;
    setLoading(true);
    try {
      const res = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
      });
      const cart = await res.json();
      renderCart(cart);
      updateBadges(cart.item_count);
    } catch (err) {
      console.error('[DevīCo cart] fetch error', err);
    } finally {
      setLoading(false);
    }
  }

  async function fetchCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      updateBadges(cart.item_count);
    } catch (_) {}
  }

  // ── Render ────────────────────────────────────────────
  function renderCart(cart) {
    const linesWrap  = drawer.querySelector(SELECTORS.linesWrap);
    const emptyState = drawer.querySelector(SELECTORS.emptyState);
    const subtotal   = drawer.querySelector(SELECTORS.subtotal);
    const count      = drawer.querySelector(SELECTORS.count);

    if (count) count.textContent = cart.item_count > 0 ? `— ${String(cart.item_count).padStart(2,'0')}` : '';
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    updateShippingBar(cart.total_price);

    if (cart.item_count === 0) {
      if (linesWrap)  linesWrap.hidden  = true;
      if (emptyState) emptyState.hidden = false;
      return;
    }
    if (emptyState) emptyState.hidden = true;
    if (linesWrap)  linesWrap.hidden  = false;

    const lines = drawer.querySelector('[data-cart-line-list]');
    if (!lines) return;
    lines.innerHTML = cart.items.map(renderLine).join('');

    // Bind stepper and remove buttons
    lines.querySelectorAll('[data-qty-minus]').forEach(btn =>
      btn.addEventListener('click', () => changeQty(btn.closest('[data-line-key]').dataset.lineKey, -1))
    );
    lines.querySelectorAll('[data-qty-plus]').forEach(btn =>
      btn.addEventListener('click', () => changeQty(btn.closest('[data-line-key]').dataset.lineKey, 1))
    );
    lines.querySelectorAll('[data-remove-line]').forEach(btn =>
      btn.addEventListener('click', () => removeLine(btn.dataset.lineKey))
    );
  }

  function renderLine(item) {
    const hasCustom = item.properties && Object.keys(item.properties).some(k => k[0] !== '_' && item.properties[k]);
    const customHtml = hasCustom ? renderCustomProps(item.properties) : '';
    const img = item.image
      ? `<img src="${item.image}" alt="${escHtml(item.product_title)}" loading="lazy">`
      : '';

    return `
    <div class="cart-drawer__line" data-line-key="${item.key}">
      <a class="cart-drawer__line-image" href="${item.url}">${img}</a>
      <div class="cart-drawer__line-info">
        <a class="cart-drawer__line-name" href="${item.url}">${escHtml(item.product_title)}</a>
        <span class="cart-drawer__line-variant">${escHtml(item.variant_title || '')}</span>
        <div class="cart-drawer__line-qty">
          <button data-qty-minus aria-label="Decrease quantity">−</button>
          <span class="cart-drawer__line-qty-num">${item.quantity}</span>
          <button data-qty-plus aria-label="Increase quantity">+</button>
        </div>
        ${customHtml}
        <div style="display:flex;justify-content:space-between;align-items:center;margin-top:10px;">
          <span class="cart-drawer__line-price">${formatMoney(item.final_line_price)}</span>
          <button class="cart-drawer__line-remove" data-remove-line data-line-key="${item.key}" aria-label="Remove ${escHtml(item.product_title)}">Remove</button>
        </div>
      </div>
    </div>`;
  }

  function renderCustomProps(props) {
    const rows = Object.entries(props)
      .filter(([k, v]) => k[0] !== '_' && v)
      .map(([k, v]) => `<div><dt>${escHtml(k)}</dt><dd>${escHtml(String(v))}</dd></div>`)
      .join('');
    if (!rows) return '';
    return `<details class="cart-drawer__line-custom">
      <summary>View customization</summary>
      <dl>${rows}</dl>
    </details>`;
  }

  // ── Quantity change ───────────────────────────────────
  async function changeQty(key, delta) {
    if (isLoading) return;
    setLoading(true);
    try {
      // First get current qty
      const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await cartRes.json();
      const item = cart.items.find(i => i.key === key);
      if (!item) { setLoading(false); return; }
      const newQty = Math.max(0, item.quantity + delta);
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty }),
      });
      await fetchAndRender();
    } catch (err) {
      console.error('[DevīCo cart] qty change error', err);
    } finally {
      setLoading(false);
    }
  }

  // ── Remove line ───────────────────────────────────────
  async function removeLine(key) {
    if (isLoading) return;
    // Animate out
    const line = drawer.querySelector(`[data-line-key="${key}"]`);
    if (line) {
      line.classList.add('is-removing');
      await new Promise(r => setTimeout(r, 280));
    }
    setLoading(true);
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });
      await fetchAndRender();
    } catch (err) {
      console.error('[DevīCo cart] remove error', err);
    } finally {
      setLoading(false);
    }
  }

  // ── Shipping bar ──────────────────────────────────────
  function updateShippingBar(totalPrice) {
    const fill = drawer && drawer.querySelector(SELECTORS.shippingFill);
    const text = drawer && drawer.querySelector(SELECTORS.shippingText);
    if (!fill || !text || FREE_SHIPPING_THRESHOLD === 0) return;
    const pct = Math.min(100, Math.round((totalPrice / FREE_SHIPPING_THRESHOLD) * 100));
    fill.style.width = pct + '%';
    if (totalPrice >= FREE_SHIPPING_THRESHOLD) {
      text.innerHTML = '<em>Complimentary shipping unlocked</em>';
    } else {
      const remaining = formatMoney(FREE_SHIPPING_THRESHOLD - totalPrice);
      text.innerHTML = `${remaining} away from <em>complimentary shipping</em>`;
    }
  }

  // ── Badge update ──────────────────────────────────────
  function updateBadges(count) {
    document.querySelectorAll(SELECTORS.countBadge).forEach(el => {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
      if (count > 0) {
        el.classList.add('bump');
        setTimeout(() => el.classList.remove('bump'), 400);
      }
    });
  }

  // ── Toast ─────────────────────────────────────────────
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    setTimeout(() => toast.classList.remove('is-visible'), 2800);
  }

  // ── Loading state ─────────────────────────────────────
  function setLoading(state) {
    isLoading = state;
    if (!loading) return;
    loading.classList.toggle('is-visible', state);
  }

  // ── Utilities ──────────────────────────────────────────
  function formatMoney(cents) {
    const amount = Number(cents || 0);
    const format = window.DEVICO_CONFIG?.moneyFormat || '₹{{amount_no_decimals}}';
    const value = amount / 100;
    const code = window.Shopify?.currency?.active || 'INR';
    const comma = (n, decimals=0) => n.toLocaleString('en-IN', {minimumFractionDigits:decimals, maximumFractionDigits:decimals});
    let rendered;
    if (format.includes('{{amount_no_decimals}}')) rendered = format.replace('{{amount_no_decimals}}', comma(value, 0));
    else if (format.includes('{{amount_with_comma_separator}}')) rendered = format.replace('{{amount_with_comma_separator}}', comma(value, 2));
    else if (format.includes('{{amount_no_decimals_with_comma_separator}}')) rendered = format.replace('{{amount_no_decimals_with_comma_separator}}', comma(value, 0));
    else if (format.includes('{{amount_with_apostrophe_separator}}')) rendered = format.replace('{{amount_with_apostrophe_separator}}', value.toFixed(2).replace('.', '\u2032'));
    else rendered = format.replace('{{amount}}', comma(value, code === 'INR' ? 0 : 2));
    if (rendered === format) {
      try { const formatted = new Intl.NumberFormat('en-IN', {style:'currency', currency:code, maximumFractionDigits:2}).format(value); return formatted.replace(/Rs\.?\s*/gi, '₹'); } catch (_) {}
    }
    return rendered.replace(/Rs\.?\s*/gi, '₹');
  }
  function escHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  // ── Expose for external scripts ────────────────────────
  window.DevicoCart = { open: openDrawer, close: closeDrawer, refresh: fetchAndRender };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // About page: restrained, accessible editorial reveals.
  (function initAboutPageMotion(){
    const root = document.querySelector('.about-hero');
    if (!root) return;
    const items = Array.from(document.querySelectorAll('[data-about-reveal]'));
    if (!items.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    items.forEach((item, index) => {
      item.style.setProperty('--about-delay', `${Math.min(index % 3, 2) * 75}ms`);
    });
    document.body.classList.add('about-motion-ready');
    if (!('IntersectionObserver' in window)) {
      items.forEach(item => item.classList.add('is-about-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-about-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    items.forEach(item => observer.observe(item));
  })();

})();

;
